<template>
  <v-container class="container">
    <v-row class="custom-row-overflow">
      <v-col cols="12">
        <p class="title">{{ $t('REPAIR_FILE_DETAIL_ACTION_DRAWER.TITLE') }}</p>
      </v-col>
      <v-col cols="12">
        <p class="sub-title">
          {{ $t('REPAIR_FILE_DETAIL_ACTION_DRAWER.SUB_TITLE.CUSTOMER_SUPPORT') }}
        </p>
      </v-col>
      <v-col cols="12" md="6">
        <v-btn
          class="button"
          :disabled="
            !checkRepairFileStatusDetailPricingSentToCustomerRelaunch() ||
            !checkPermission(['DISTRIBUTOR_UPDATE_REPAIR_FILE'])
          "
          :loading="loading"
          variant="outlined"
          @click="customerRelaunch()"
        >
          <div class="d-flex align-content-center pa-6">
            <img alt="reload-svg" class="mr-1" src="@/assets/icons/file/reload.svg" />
            <p>{{ $t('REPAIR_FILE_DETAIL_ACTION_DRAWER.BUTTON.CUSTOMER_RELAUNCH_BY_PHONE') }}</p>
          </div>
        </v-btn>
      </v-col>
      <v-col class="d-flex" cols="12" md="6">
        <div class="d-flex align-center justify-space-between">
          <span
            class="status-dot"
            :class="{
              [getDotClass('estimatePackage')]:
                currentRepairFile.status_detail ===
                RepairFileStatusDetailConstant.PRICING_SENT_TO_CUSTOMER
            }"
          />
          <p
            :class="{
              'disabled-text':
                !checkRepairFileStatusDetailPricingSentToCustomerRelaunch() ||
                !currentRepairFile.estimate_package_last_relaunch_date
            }"
          >
            {{ $t('REPAIR_FILE_DETAIL_ACTION_DRAWER.LAST_RELAUNCH') }}
            {{
              getFormattedDate(
                currentRepairFile.estimate_package_last_relaunch_date,
                checkRepairFileStatusDetailPricingSentToCustomerRelaunch()
              )
            }}
          </p>
        </div>
      </v-col>
      <v-col class="margin-bottom" cols="12">
        <v-btn
          class="button w-100"
          :disabled="
            checkRepairFileStatusDetailToGoStepper() ||
            !checkPermission(['DISTRIBUTOR_UPDATE_REPAIR_FILE'])
          "
          :loading="loading"
          variant="outlined"
          @click="routerPush"
        >
          <div class="d-flex align-content-center pa-6">
            <img alt="file-svg" class="mr-4" src="@/assets/icons/file/file.svg" />
            <p>{{ $t('REPAIR_FILE_DETAIL_ACTION_DRAWER.CUSTOMER_ESTIMATE_REVISION') }}</p>
          </div>
        </v-btn>
      </v-col>
      <v-col cols="12">
        <p class="sub-title">{{ $t('REPAIR_FILE_DETAIL_ACTION_DRAWER.REPAIRER_ESTIMATE') }}</p>
      </v-col>
      <v-col cols="12">
        <v-btn
          class="button w-100"
          :disabled="
            checkRepairFileStatusDetailToGoEstimateRepairer() ||
            !checkPermission(['DISTRIBUTOR_UPDATE_REPAIR_FILE'])
          "
          :loading="loading"
          variant="outlined"
          @click="openEstimateRepairer()"
        >
          <div class="d-flex align-content-center pa-6">
            <img
              alt="cross-round-svg"
              class="mr-4 cross-round"
              src="@/assets/icons/file/cross_round.svg"
            />
            <p>{{ $t('REPAIR_FILE_DETAIL_ACTION_DRAWER.ADD_ESTIMATE_TO_FILE') }}</p>
          </div>
        </v-btn>
      </v-col>
      <v-col cols="12" md="6">
        <v-btn
          class="button"
          :disabled="
            !checkRepairFileStatusDetailEstimateSentToCustomerRelaunch() ||
            !checkPermission(['DISTRIBUTOR_UPDATE_REPAIR_FILE'])
          "
          :loading="loading"
          variant="outlined"
          @click="customerRelaunch()"
        >
          <div class="d-flex align-content-center pa-6">
            <img alt="reload-svg" class="mr-1" src="@/assets/icons/file/reload.svg" />
            <p>{{ $t('REPAIR_FILE_DETAIL_ACTION_DRAWER.BUTTON.CUSTOMER_RELAUNCH_BY_PHONE') }}</p>
          </div>
        </v-btn>
      </v-col>
      <v-col class="d-flex" cols="12" md="6">
        <div class="d-flex align-center justify-space-between">
          <span
            class="status-dot"
            :class="{
              [getDotClass('repairerEstimate')]:
                currentRepairFile.status_detail ===
                RepairFileStatusDetailConstant.ESTIMATE_SENT_TO_CUSTOMER
            }"
          />
          <p
            :class="{
              'disabled-text':
                !checkRepairFileStatusDetailEstimateSentToCustomerRelaunch() ||
                !currentRepairFile.repairer_estimate_last_relaunch_date
            }"
          >
            {{ $t('REPAIR_FILE_DETAIL_ACTION_DRAWER.LAST_RELAUNCH') }}
            {{
              getFormattedDate(
                currentRepairFile.repairer_estimate_last_relaunch_date,
                checkRepairFileStatusDetailEstimateSentToCustomerRelaunch()
              )
            }}
          </p>
        </div>
      </v-col>
      <v-col cols="12" class="margin-bottom">
        <v-btn
          class="button w-100"
          :disabled="
            checkRepairFileStatusDetailToGoEstimateRepairerDetail() ||
            !checkPermission(['DISTRIBUTOR_UPDATE_REPAIR_FILE'])
          "
          :loading="loading"
          variant="outlined"
          @click="openEstimateRepairerDetail()"
        >
          <div class="d-flex align-content-center pa-6">
            <img
              alt="cross-round-svg"
              class="mr-4 cross-round"
              src="@/assets/icons/file/info.svg"
            />
            <p>{{ $t('REPAIR_FILE_DETAIL_ACTION_DRAWER.NOTIFY_THE_REPAIRER') }}</p>
          </div>
        </v-btn>
      </v-col>
      <v-col cols="12">
        <p class="sub-title">{{ $t('REPAIR_FILE_DETAIL_ACTION_DRAWER.CLOSE_CASE') }}</p>
      </v-col>
      <v-col cols="12">
        <v-btn
          class="button w-100 v-btn--no-hover"
          :disabled="
            checkRepairFileStatusDetailToRetrieveEquipmentCustomer() ||
            !checkPermission(['DISTRIBUTOR_UPDATE_REPAIR_FILE'])
          "
          :loading="loading"
          variant="outlined"
          @click="openDeliveryClient()"
        >
          <div class="d-flex align-content-center pa-6">
            <img
              alt="cross-round-svg"
              class="mr-4 cross-round"
              src="@/assets/icons/file/check_round.svg"
            />
            <p>{{ $t('REPAIR_FILE_DETAIL_ACTION_DRAWER.RETRIEVE_EQUIPMENT_CUSTOMER') }}</p>
          </div>
        </v-btn>
      </v-col>

      <v-col cols="4">
        <v-btn
          class="button-square"
          :disabled="!checkPermission(['DISTRIBUTOR_RENTAL_CREATE']) || this.rentalFileId !== null"
          :loading="loading"
          variant="outlined"
          @click="redirectToRentalPage()"
        >
          <div class="flex-column align-content-center pa-6">
            <v-icon alt="rental-icon" class="cross-round mb-4" icon="mdi-boomerang" />
            <p class="square-button-label text-wrap">
              {{ $t('REPAIR_FILE_DETAIL_ACTION_DRAWER.BUTTON.ADD_RENTAL') }}
            </p>
          </div>
        </v-btn>
      </v-col>
      <v-col cols="4">
        <v-btn
          class="button-square"
          :disabled="
            checkRepairFileStatusDetailToEnableManualChangeStatus() ||
            !checkPermission(['DISTRIBUTOR_UPDATE_REPAIR_FILE'])
          "
          :loading="loading"
          variant="outlined"
          @click="showUpdateRepairFileStatusModal()"
        >
          <div class="flex-column justify-center pa-6">
            <img
              alt="cross-round-svg"
              class="cross-round mb-4"
              src="@/assets/icons/file/flag.svg"
            />
            <p class="square-button-label text-wrap">
              {{ $t('REPAIR_FILE_DETAIL_ACTION_DRAWER.BUTTON.CHANGE_STATUS') }}
            </p>
          </div>
        </v-btn>
      </v-col>
      <v-col cols="4">
        <v-btn
          class="button-square margin-bottom"
          :loading="loading"
          :disabled="!checkPermission(['DISTRIBUTOR_CLOSE_REPAIR_FILE'])"
          variant="outlined"
          @click="deleteRepairFile()"
        >
          <div class="flex-column justify-center pa-6">
            <img
              alt="cross-round-svg"
              class="cross-round mb-4"
              src="@/assets/icons/file/trash.svg"
            />
            <p class="square-button-label text-wrap">{{ $t('COMMON.BUTTON.DELETE') }}</p>
          </div>
        </v-btn>
      </v-col>
      <v-col cols="4" />
      <v-col cols="4">
        <v-btn
          class="button w-100"
          :disabled="false"
          :loading="loading"
          variant="outlined"
          @click="closeNewAction()"
        >
          {{ $t('COMMON.BUTTON.CANCEL') }}
        </v-btn>
      </v-col>
      <v-col cols="4" />
    </v-row>
  </v-container>
  <DeleteRepairFileModal ref="deleteRepairFileModal" />
  <RelaunchCustomerModal ref="relaunchCustomerModal" />
</template>

<script>
import RepairFileStatusDetailConstant from '@/constants/repairFileStatusDetailConstant'
import DeleteRepairFileModal from '@/components/modal/repair-file/DeleteRepairFileModal.vue'
import { auth as $store } from '@/store/AuthModule'
import RepairFileService from '@/services/RepairFileService'
import RelaunchCustomerModal from '@/components/modal/repair-file/RelaunchCustomerModal.vue'
import { RepairFile } from '@/models/RepairFile'
import { displayToast, checkPermission, handleResponseError } from '@/components/utils/globalFunction'

export default {
  computed: {
    RepairFileStatusDetailConstant() {
      return RepairFileStatusDetailConstant
    }
  },
  components: { RelaunchCustomerModal, DeleteRepairFileModal },
  props: {
    currentRepairFile: RepairFile,
    rentalFileId: Object
  },
  data() {
    return {
      loading: false,
      error: null
    }
  },
  methods: {
    checkPermission,

    openDeliveryClient() {
      if (this.rentalFileId != null) {
        this.$emit('openRentalWarningModal')
      }

      this.$emit('openDeliveryClient')
    },
    openEstimateRepairer() {
      this.$emit('openEstimateRepairer')
    },
    openEstimateRepairerDetail() {
      this.$emit('openEstimateRepairerDetail')
    },
    checkRepairFileStatusDetailToRetrieveEquipmentCustomer() {
      switch (this.currentRepairFile.status_detail) {
        case RepairFileStatusDetailConstant.REPAIR_FILE_CREATED:
        case RepairFileStatusDetailConstant.COLLECTION_TO_REPAIRER:
        case RepairFileStatusDetailConstant.RECEPTION_AT_REPAIRER:
        case RepairFileStatusDetailConstant.DIAGNOSTIC_MANUFACTURER_RECEIVED:
        case RepairFileStatusDetailConstant.ESTIMATE_CREATED:
        case RepairFileStatusDetailConstant.FORCE_ESTIMATE_CREATED:
        case RepairFileStatusDetailConstant.ESTIMATE_SENT_TO_CUSTOMER:
        case RepairFileStatusDetailConstant.FORCE_ESTIMATE_SENT_TO_CUSTOMER:
        case RepairFileStatusDetailConstant.ESTIMATE_CUSTOMER_DECISION_SENT_TO_REPAIRER:
        case RepairFileStatusDetailConstant.FORCE_ESTIMATE_CUSTOMER_DECISION_SENT_TO_REPAIRER:
        case RepairFileStatusDetailConstant.IN_REPARATION:
        case RepairFileStatusDetailConstant.SENT_BACK_BY_REPAIRER:
        case RepairFileStatusDetailConstant.RECEIPT_AT_STORE:
        case RepairFileStatusDetailConstant.SENT_AVAILABLE_TO_CUSTOMER:
          return false
        default:
          return true
      }
    },
    closeNewAction() {
      this.$emit('closeNewAction')
    },
    checkRepairFileStatusDetailPricingSentToCustomerRelaunch() {
      return (
        this.currentRepairFile.status_detail ===
        RepairFileStatusDetailConstant.PRICING_SENT_TO_CUSTOMER
      )
    },
    checkRepairFileStatusDetailEstimateSentToCustomerRelaunch() {
      return (
        this.currentRepairFile.status_detail ===
        RepairFileStatusDetailConstant.ESTIMATE_SENT_TO_CUSTOMER
      )
    },
    checkRepairFileStatusDetailToGoStepper() {
      switch (this.currentRepairFile.status_detail) {
        case RepairFileStatusDetailConstant.PRODUCT_SELECTED:
        case RepairFileStatusDetailConstant.BREAKDOWN_EVALUATED:
        case RepairFileStatusDetailConstant.GUARANTEE_EVALUATED:
        case RepairFileStatusDetailConstant.PRICING_SENT_TO_CUSTOMER:
        case RepairFileStatusDetailConstant.PRICING_EVALUATED:
        case RepairFileStatusDetailConstant.INFORMATION_RETRIEVED:
        case RepairFileStatusDetailConstant.PROSPECT_CLIENT_INFORMATION_RETRIEVED:
        case RepairFileStatusDetailConstant.PROSPECT_REQUEST_SENT:
        case RepairFileStatusDetailConstant.PROSPECT_MANUFACTURER_RESPONSE:
        case RepairFileStatusDetailConstant.PROSPECT_MANUFACTURER_RESPONSE_VALIDATED:
        case RepairFileStatusDetailConstant.TRANSPORTER_REPAIR_FILE_TRANSFER:
        case RepairFileStatusDetailConstant.INTERNAL_COMMAND_NUMBER_LINKED:
        case RepairFileStatusDetailConstant.FINALIZE_REPAIR_FILE:
          return false
        default:
          return true
      }
    },
    checkRepairFileStatusDetailToGoEstimateRepairer() {
      switch (this.currentRepairFile.status_detail) {
        case RepairFileStatusDetailConstant.REPAIR_FILE_CREATED:
        case RepairFileStatusDetailConstant.COLLECTION_TO_REPAIRER:
        case RepairFileStatusDetailConstant.RECEPTION_AT_REPAIRER:
        case RepairFileStatusDetailConstant.DIAGNOSTIC_MANUFACTURER_RECEIVED:
          return false
        default:
          return true
      }
    },
    checkRepairFileStatusDetailToGoEstimateRepairerDetail() {
      switch (this.currentRepairFile.status_detail) {
        case RepairFileStatusDetailConstant.ESTIMATE_CREATED:
        case RepairFileStatusDetailConstant.ESTIMATE_SENT_TO_CUSTOMER:
          return false
        default:
          return true
      }
    },
    checkRepairFileStatusDetailToEnableManualChangeStatus() {
      switch (this.currentRepairFile.status_detail) {
        case RepairFileStatusDetailConstant.REPAIR_FILE_CREATED:
        case RepairFileStatusDetailConstant.COLLECTION_TO_REPAIRER:
        case RepairFileStatusDetailConstant.RECEPTION_AT_REPAIRER:
        case RepairFileStatusDetailConstant.DIAGNOSTIC_MANUFACTURER_RECEIVED:
        case RepairFileStatusDetailConstant.ESTIMATE_CUSTOMER_DECISION_SENT_TO_REPAIRER:
        case RepairFileStatusDetailConstant.IN_REPARATION:
        case RepairFileStatusDetailConstant.SENT_BACK_BY_REPAIRER:
        case RepairFileStatusDetailConstant.RECEIPT_AT_STORE:
        case RepairFileStatusDetailConstant.SENT_AVAILABLE_TO_CUSTOMER:
          return false
        default:
          return true
      }
    },
    routerPush() {
      switch (this.currentRepairFile.status_detail) {
        case RepairFileStatusDetailConstant.TRANSPORTER_REPAIR_FILE_TRANSFER:
          this.$router.push('/repair-file/shipping/' + this.$route.params.repairFileBoomerangId)
          break
        case RepairFileStatusDetailConstant.FINALIZE_REPAIR_FILE:
          this.$router.push('/repair-file/finalization/' + this.$route.params.repairFileBoomerangId)
          break
        default:
          this.$router.push('/repair-file/' + this.$route.params.repairFileBoomerangId)
      }
    },
    async deleteRepairFile() {
      const confirm = await this.$refs.deleteRepairFileModal.show({
        title: this.$t('REPAIR_FILE_DETAIL.MODAL.DELETE_REPAIR_FILE.TITLE'),
        message: this.$t('REPAIR_FILE_DETAIL.MODAL.DELETE_REPAIR_FILE.MESSAGE'),
        warning: this.$t('REPAIR_FILE_DETAIL.MODAL.DELETE_REPAIR_FILE.WARNING'),
        validateButton: this.$t('COMMON.BUTTON.DELETE'),
        cancelButton: this.$t('COMMON.BUTTON.CANCEL')
      })
      if (confirm) {
        try {
          this.loading = true
          const data = {
            repair_file_boomerang_id: this.currentRepairFile.boomerang_id,
            requestor_collaborator_id: $store.state.currentCollaborator.technical_id
          }
          await RepairFileService.deleteRepairFile(data)
          displayToast(this.$t('REPAIR_FILE_DETAIL.MESSAGE.DELETE.SUCCESS'), 'success')
          this.$router.push({ name: 'Dashboard' })
        } catch (error) {
          handleResponseError(error)
        } finally {
          this.loading = false
        }
      }
    },
    async showUpdateRepairFileStatusModal() {
      this.$emit('closeNewAction')
      this.$emit('showUpdateRepairFileStatusModal')
    },
    async customerRelaunch() {
      const confirm = await this.$refs.relaunchCustomerModal.show({
        title: this.$t('REPAIR_FILE_DETAIL.MODAL.CUSTOMER_RELAUNCH.TITLE'),
        message: this.$t('REPAIR_FILE_DETAIL.MODAL.CUSTOMER_RELAUNCH.MESSAGE'),
        validateButton: this.$t('COMMON.BUTTON.CONFIRM'),
        cancelButton: this.$t('COMMON.BUTTON.CANCEL')
      })
      if (confirm) {
        try {
          this.loading = true
          const data = {
            repair_file_id: this.currentRepairFile.technical_id,
            requestor_collaborator_id: $store.state.currentCollaborator.technical_id
          }
          await RepairFileService.relaunchCustomer(data)
          displayToast(this.$t('REPAIR_FILE_DETAIL.MESSAGE.RELAUNCH.SUCCESS'), 'success')
          this.$emit('updateCurrentRepairFile')
        } catch (error) {
          handleResponseError(error)
        } finally {
          this.loading = false
        }
      }
    },
    getFormattedDate(date, checkRepairFileStatusDetail) {
      if (checkRepairFileStatusDetail === false) {
        return 'XX/XX/XXXX'
      }
      if (date) {
        return new Date(date).toLocaleDateString()
      } else {
        return 'XX/XX/XXXX'
      }
    },
    getDotClass(typeRelaunch) {
      let last_relaunch_date = this.currentRepairFile.estimate_package_last_relaunch_date
      let workingDays = this.currentRepairFile.estimate_package_last_relaunch_date_day_count
      if (typeRelaunch === 'repairerEstimate') {
        last_relaunch_date = this.currentRepairFile.repairer_estimate_last_relaunch_date
        workingDays = this.currentRepairFile.repairer_estimate_last_relaunch_date_day_count
      }

      if (workingDays < 3 && last_relaunch_date) {
        return 'status-dot dot-green'
      } else if (workingDays >= 3 && workingDays < 6 && last_relaunch_date) {
        return 'status-dot dot-orange'
      } else if (workingDays >= 6 && last_relaunch_date) {
        return 'status-dot dot-red'
      }
      return 'status-dot'
    },
    redirectToRentalPage() {
      this.$router.push('/rental-module/product-list/' + this.currentRepairFile.boomerang_id)
    }
  }
}
</script>

<!--unscoped pas le choix pour changer le background color-->
<style>
.my-custom-drawer .v-navigation-drawer__content {
  border: unset !important;
  background-color: white !important;
}
</style>

<style scoped>
.title {
  color: #000;
  text-align: center;
  font-size: 28px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  margin-bottom: 15px;
}

.sub-title {
  color: #000;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
}

.container {
  padding: 20px 20px;
}

.button {
  display: flex;
  padding: 10px 20px;
  justify-content: center;
  align-items: center;
  text-transform: none !important;
  border-radius: 20px;
  border: 1px solid #000;
  background: #fff;
  color: #000;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}

.status-dot {
  margin-right: 10px;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #acacac;
}

.dot-green {
  background: #86c94e;
}

.dot-orange {
  background: var(--warning-color);
}

.dot-red {
  background: var(--error-color);
}

.cross-round {
  width: 14px;
  height: 14px;
}

.margin-bottom {
  margin-bottom: 20px;
}

.button-square {
  border: 1px solid #000;
  display: flex;
  width: 100%;
  height: 121px;
  text-transform: none !important;
  border-radius: 20px;
}

.square-button-label {
  text-align: center;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}

.disabled-text {
  color: rgba(0, 0, 0, 0.4);
}

.custom-row-overflow {
  overflow: auto;
  max-height: 90vh;
  margin-right: -21px;
  margin-top: -21px;
}
</style>
